module.exports = __webpack_public_path__ + "img/microphone-slash.0ec9e07e.svg";